function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Image } from "semantic-ui-react";
const PostIcon = props => {
  const {
    media
  } = props;
  if (media && media.guid && media.guid.rendered) {
    return /*#__PURE__*/React.createElement(Image, _extends({}, props, {
      src: media.guid.rendered
    }));
  } else {
    return null;
  }
};
export default PostIcon;